import { render, staticRenderFns } from "./long-right-arrow.vue?vue&type=template&id=5f35ade5&scoped=true"
import script from "./long-right-arrow.vue?vue&type=script&lang=js"
export * from "./long-right-arrow.vue?vue&type=script&lang=js"
import style0 from "./long-right-arrow.vue?vue&type=style&index=0&id=5f35ade5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f35ade5",
  null
  
)

export default component.exports